import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RetrySendCloudLabelMutationVariables = Types.Exact<{
  order_id: Types.Scalars['ID'];
}>;


export type RetrySendCloudLabelMutation = { __typename?: 'Mutation', retrySendCloudLabel: { __typename?: 'RetrySendCloudLabelResult', order_id: string, outcome: Types.RetrySendCloudLabelOutcome, status: Types.MerchantOrderStatusEnum } };


export const RetrySendCloudLabelDocument = gql`
    mutation RetrySendCloudLabel($order_id: ID!) {
  retrySendCloudLabel(order_id: $order_id) {
    order_id
    outcome
    status
  }
}
    `;
export type RetrySendCloudLabelMutationFn = Apollo.MutationFunction<RetrySendCloudLabelMutation, RetrySendCloudLabelMutationVariables>;

/**
 * __useRetrySendCloudLabelMutation__
 *
 * To run a mutation, you first call `useRetrySendCloudLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrySendCloudLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrySendCloudLabelMutation, { data, loading, error }] = useRetrySendCloudLabelMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *   },
 * });
 */
export function useRetrySendCloudLabelMutation(baseOptions?: Apollo.MutationHookOptions<RetrySendCloudLabelMutation, RetrySendCloudLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetrySendCloudLabelMutation, RetrySendCloudLabelMutationVariables>(RetrySendCloudLabelDocument, options);
      }
export type RetrySendCloudLabelMutationHookResult = ReturnType<typeof useRetrySendCloudLabelMutation>;
export type RetrySendCloudLabelMutationResult = Apollo.MutationResult<RetrySendCloudLabelMutation>;
export type RetrySendCloudLabelMutationOptions = Apollo.BaseMutationOptions<RetrySendCloudLabelMutation, RetrySendCloudLabelMutationVariables>;